module.exports = __webpack_public_path__ + "static/media/Tire-protection.638fea61.svg";